import axios from 'axios'

// Define the expected response data structure
interface ErrorResponseData {
  error?: string
  message?: string
  [key: string]: unknown // Allow other properties
}

export const getAxiosErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    // It's an Axios error
    if (error.response) {
      // Server responded with error status
      const data = error.response.data as ErrorResponseData
      return data?.error || data?.message || `Server error: ${error.response.status}`
    } else if (error.request) {
      // Request made but no response
      return 'No response from server. Please check your connection.'
    } else {
      // Error in request setup
      return error.message || 'Request setup error'
    }
  } else if (error instanceof Error) {
    // It's a regular JavaScript Error
    return error.message
  } else if (typeof error === 'string') {
    // It's a string
    return error
  }
  // Unknown error type
  return 'An unexpected error occurred'
}